const isInteger = val => {
  const integerRegex = /^-?\d+$/;

  if (!integerRegex.test(val)) return false;
  if (Number.isNaN(parseInt(val, 10))) return false;
  return true;
};

export default isInteger;
